import { Link, useParams } from "react-router-dom";
import { PageHeader } from "@/components/Layout";
import { ClientLedger } from "@/components/ledger";
import { ErrorNote } from "@/components/ui";
import { errorMessage } from "@/lib/api";
import { useClient } from "@/lib/queries";

/** Il registro movimenti, fuori dalla scheda cliente: era incorporato, adesso ha una rotta sua. */
export function ClientLedgerPage() {
  const { id = "" } = useParams();
  const client = useClient(id);

  if (client.isLoading) return <p className="px-6 py-6 text-sm text-muted">Caricamento…</p>;
  if (client.error || !client.data) {
    return (
      <div className="px-6 py-6">
        <ErrorNote>{client.error ? errorMessage(client.error) : "Cliente non trovato"}</ErrorNote>
        <Link to="/clienti" className="mt-3 inline-block text-sm text-muted hover:text-ink">
          Torna ai clienti
        </Link>
      </div>
    );
  }

  const c = client.data;
  return (
    <>
      <PageHeader
        title="Registro movimenti"
        subtitle={c.name}
        actions={
          <Link
            to={`/clienti/${c.id}`}
            className="inline-flex items-center justify-center gap-1.5 rounded border border-line bg-raised px-3 py-1.5 text-sm font-medium text-ink hover:border-muted/60"
          >
            Torna alla scheda
          </Link>
        }
      />
      <div className="px-6 py-5">
        <ClientLedger client={c} />
      </div>
    </>
  );
}
